import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { OfferingDetailsMultiPass } from "../template_offering_details_multipass";
import { useRentryAnalytics } from "./rentry_analytics";
import { partnerConfig } from "./rentry_partner_config";

const Theme = lazyWithRetry(() => import("./rentry_theme"));

export function OfferingRentryMultiPass() {
  useRentryAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsMultiPass
        showAddress
        showDirections
        partnerConfig={partnerConfig}
        data={{
          title: "Multi Pass",
        }}
      />
    </Fragment>
  );
}
